<div
  class="row align-items-center search-entity-container"
  [attr.data-cta-passed]="ctaPassed"
  [attr.data-script-done]="initDone"
>
  <div class="product-spotlight d-block d-md-none text-center">
    {{ 'productSpotlight' | translate }}
  </div>

  <!-- Left side: image -->
  <div class="search-entity-image col-md-2 m-auto">
    <img src="{{ searchResultEntry.image }}" class="img-fluid search-entity-image" alt="" />
  </div>

  <!-- Right side: Text content-->
  <div class="col col-md-10 search-entity-right-col">
    <div class="d-flex flex-column">
      <div class="product-spotlight d-none d-md-block">
        {{ 'productSpotlight' | translate }}
      </div>

      <!-- Title -->
      <div class="search-entity-title">
        <a
          href="{{ searchResultEntry.uri }}"
          id="titleUri"
          class="search-entity-title-url"
          [title]="searchResultEntry.title"
          [appResultClickTracking]="searchResultEntry"
          englishDisplayString="{{ this.translateService.instant('productDetailsEn') }}"
          *ngIf="searchResultEntry.uri"
        >
          {{ searchResultEntry.title }}
          <ng-container *ngIf="searchResultEntry.subTitle">
            <br />
            <span class="search-entity-subtitle">
              {{ searchResultEntry.subTitle }}
            </span>
          </ng-container>
        </a>
        <span id="titleUriSpan" class="search-entity-title-url-span" *ngIf="!searchResultEntry.uri">
          {{ searchResultEntry.title }}
          <ng-container *ngIf="searchResultEntry.subTitle">
            <br />
            <span class="search-entity-subtitle">
              {{ searchResultEntry.subTitle }}
            </span>
          </ng-container>
        </span>
      </div>

      <!-- Price -->
      <div class="search-entity-price mx-0" *ngIf="showPrice && !searchResultEntry.specialEdition">
        {{ pricePrefix | uppercase }}
        <span
          [ngClass]="
            discountedPriceExist ? 'search-entity-mashup-discounted-price' : 'search-entity-mashup-no-discount-price'
          "
        >
          {{ price }}
        </span>
        <div class="search-entity-mashup-entitled-price" *ngIf="discountedPriceExist">{{ discountedPrice }}</div>
      </div>

      <!-- Extra Info -->
      <div class="search-entity-extra-info mx-auto mx-md-0" *ngIf="extraInfoUnderTheTitle">
        <span [innerHTML]="extraInfoUnderTheTitle"></span>
      </div>

      <!-- Teaser -->
      <div class="search-entity-teaser">
        <div [innerHTML]="searchResultEntry.teaser"></div>
      </div>
    </div>

    <!-- Primary, secondary buttons, contact us -->
    <app-search-entity-cta
      [searchResultEntry]="searchResultEntry"
      [isShowContactUs]="isShowContactUs"
      [isShowPurchaseUrl]="isShowPurchaseUrl"
      [listPrice]="listPrice"
      [currencyCode]="currencyCode"
    ></app-search-entity-cta>
  </div>
</div>
